import { TextCell as l, StatusCell as e, CellSelection as t, DateCell as o, QuickOperations as C, CellWithCheckBox as c, AmountCell as i } from "./DefaultCellComponents.js";
const a = {
  textCell: l,
  statusCell: e,
  cellSelection: t,
  dateCell: o,
  quickOperations: C,
  cellWithCheckBox: c,
  amountCell: i
};
export {
  a as defaultCellComponents
};
//# sourceMappingURL=index.js.map
